
// loginApi
export const LOGIN_URL: string = '/web/admin/users/login'

export const GET_USER_INFO_URL: string = '/web/admin/users/getUserInfo'

export const GET_ADMIN_SIDER_STORE_URL: string = '/web/admin/application/getApplicationList'